module.exports = __webpack_public_path__ + "static/media/007.f2eabff3.jpg";